import React from 'react';
import { createRoot } from 'react-dom/client';
import './sentry';
import './styles';
import './app/bootstrap';
import App from './App';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Missing #root element');
}

createRoot(rootEl).render(
  // NOTE: StrictMode will AUTOMATICALLY mount, unmount, and then remount the component. This is
  // meant to validate that the component doesn't have any side effects. This will usually result
  // in API calls being made twice when we might only expect it to be called once. In production,
  // it will not happen.
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
